import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Header from "../../../layouts/Header";
import { ReactComponent as OCRIcon } from "../../../assets/navigation/Nav-OCR.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  OcrDocumentAccept,
  OcrDocumentDelete,
  OcrDocumentDuplicate,
  OcrGetAllOCRDocuments,
} from "../../../redux/actions/action";
import { useHistory } from "react-router-dom";
import { europeanFormatWithSymbol } from "../../../utils/European-Format/NumberFormatter";
import AppDatePicker from "../../../components/Common/AppDatePicker";
import Calender from "../../../assets/icons/CalendarGray.svg";
import Pagination from "../../../components/Pagination/Pagination";
import upArrow from "../../../assets/icons/upArrow.png";
import FilterContacts from "../../../assets/icons/FilterContacts.svg";
import Kebab from "../../../assets/icons/Kebab contacts.svg";
import Reload from "../../../assets/icons/Reload.svg";
import delete1 from "../../../assets/icons/Group 2723.svg";
import DeletePopUp from "../../../components/Dailogs/DeletePopUp";
import { CopyIcon } from "../../../assets";

const SORT_BY_OPTIONS = [
  { label: "Date", value: "DATE" },
  { label: "Doc ID", value: "DOCID" },
  { label: "Client", value: "CLIENT" },
  { label: "Due Date", value: "DUEDATE" },
  { label: "Status", value: "STATUS" },
];

const OcrList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const filterPopupRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const kebabRef = useRef();
  const [menuActive, setMenuActive] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const ocrDocumentsRes = useSelector((state) => state.user.ocrAllDocuments);
  const ocrDocumentAcceptRes = useSelector(
    (state) => state.user.ocrDocumentAccept,
  );
  const ocrDocumentDuplicateRes = useSelector(
    (state) => state.user.ocrDocumentDuplicate,
  );
  const ocrDocumentDeleteRes = useSelector(
    (state) => state.user.ocrDocumentDelete,
  );
  const [totalPages, setTotalPages] = useState(0);
  const [sortedValue, setSortedValue] = useState(SORT_BY_OPTIONS[0].value);
  const [filtersPopupShow, setFiltersPopupShow] = useState(false);
  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);
  const [ocrList, setOcrList] = useState([]);
  const [statusFilter, setStatusFilter] = useState(["All"]);

  const [apiFilters, setApiFilters] = useState({
    fromDate: new Date(),
    toDate: new Date(),
    sortBy: "DATE",
    sortDirection: "DESC",
    statusFilter: ["Pendent", "Accepted", "Deleted"],
    perPage: 10,
    currentPage: 0,
  });

  useEffect(() => {
    if (ocrDocumentsRes.status) {
      setOcrList(ocrDocumentsRes.data);
      setTotalPages(Math.ceil(ocrDocumentsRes.totalCount / apiFilters.perPage));
    }
  }, [ocrDocumentsRes]);

  useEffect(() => {
    dispatch(OcrGetAllOCRDocuments(apiFilters));
  }, [apiFilters, dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target) &&
        (!fromDateRef.current || !fromDateRef.current.contains(event.target)) &&
        (!toDateRef.current || !toDateRef.current.contains(event.target))
      ) {
        setFiltersPopupShow(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSortChange = (value) => {
    setSortedValue(value);
    setApiFilters((prev) => ({
      ...prev,
      sortBy: value,
    }));
  };

  const handleCurrentPage = (value) => {
    setApiFilters((prev) => ({
      ...prev,
      currentPage: value,
    }));
  };

  const handlePerPage = (value) => {
    setApiFilters((prev) => ({
      ...prev,
      perPage: value,
    }));
  };

  const handleDateChange = (key, date) => {
    setApiFilters((prev) => ({
      ...prev,
      [key]: date,
    }));
  };

  const handleFilterChange = (value) => {
    if (value === "All") {
      setStatusFilter(["All"]);
      setApiFilters((prev) => ({
        ...prev,
        statusFilter: ["Pendent", "Accepted", "Deleted"],
      }));
    } else {
      const updatedFilter = [value];
      setStatusFilter(updatedFilter);
      setApiFilters((prev) => ({
        ...prev,
        statusFilter: updatedFilter,
      }));
    }
  };

  const handleClearFilters = () => {
    setStatusFilter(["All"]);
    setApiFilters((prev) => ({
      ...prev,
      statusFilter: ["Pendent", "Accepted", "Deleted"],
    }));
    setFiltersPopupShow(false);
  };

  useEffect(() => {
    const { status: acceptStatus } = ocrDocumentAcceptRes;
    const { status: duplicateStatus } = ocrDocumentDuplicateRes;
    const { status: deleteStatus } = ocrDocumentDeleteRes;

    if (acceptStatus || duplicateStatus || deleteStatus) {
      dispatch(OcrGetAllOCRDocuments(apiFilters));
      setMenuActive(false);

      if (deleteStatus) {
        setShowDelete(false);
      }
    }
  }, [ocrDocumentAcceptRes, ocrDocumentDuplicateRes, ocrDocumentDeleteRes]);

  return (
    <>
      <Header leftComponent={<HeaderLeftComponent />} />
      <div>
        <div className="afterHeader gap-3 px-5">
          <SortSection
            sortedValue={sortedValue}
            onSortChange={handleSortChange}
          />
          <FilterSection
            filterPopupRef={filterPopupRef}
            filtersPopupShow={filtersPopupShow}
            setFiltersPopupShow={setFiltersPopupShow}
            statusFilter={statusFilter}
            onFilterChange={handleFilterChange}
            onClearFilters={handleClearFilters}
          />
          <DateRangePicker
            fromDate={apiFilters.fromDate}
            toDate={apiFilters.toDate}
            fromDateOpen={fromDateOpen}
            toDateOpen={toDateOpen}
            setFromDateOpen={setFromDateOpen}
            setToDateOpen={setToDateOpen}
            onDateChange={handleDateChange}
            fromDateRef={fromDateRef}
            toDateRef={toDateRef}
          />
          <button
            className="add-buttons"
            style={{ fontSize: "16px", marginLeft: "auto" }}
            onClick={() => history.push("/ocr-add")}
          >
            <OCRIcon style={{ fill: "white", marginRight: "15px" }} />
            Add New
          </button>
        </div>
        <div className="mt-3 mx-4 px-4">
          <OcrDocumentsTable
            ocrList={ocrList}
            onDocumentClick={(id) => history.push(`/ocr-update/${id}`)}
            menuActive={menuActive}
            setMenuActive={setMenuActive}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
            showDelete={showDelete}
            setShowDelete={setShowDelete}
            kebabRef={kebabRef}
            dispatch={dispatch}
          />
          {ocrList.length > 0 && (
            <Pagination
              perPage={apiFilters.perPage}
              setPerPage={handlePerPage}
              currentPage={apiFilters.currentPage}
              setCurrentPage={handleCurrentPage}
              totalPages={totalPages}
            />
          )}
        </div>
      </div>
    </>
  );
};

const HeaderLeftComponent = () => (
  <div className="d-flex align-items-center gap-4">
    <div className="ocr-form-header-primary" style={{ color: "#333333" }}>
      OCR - Accounts Payable Process
    </div>
  </div>
);

const SortSection = ({ sortedValue, onSortChange }) => {
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);

  return (
    <div className="d-flex gap-3 w-25" style={{ position: "relative" }}>
      <p className="sortBy">Sort by</p>
      <img
        className={`mt-1 pointer ${
          shortByArrow ? "downSortArrow" : "upSortArrow"
        }`}
        src={upArrow}
        alt="sort-arrow"
        onClick={() => setShortByArrow((prev) => !prev)}
      />
      <p
        className="datetext pointer"
        onClick={() => setShowShortDrop((prev) => !prev)}
      >
        {SORT_BY_OPTIONS.find((option) => option.value === sortedValue)?.label}
      </p>

      <div
        className="sortDropDiv p-3"
        style={{
          transform: showShortDrop ? "scale(1)" : "scale(0)",
          transitionDuration: "300ms",
        }}
      >
        {SORT_BY_OPTIONS.map((option) => (
          <div
            key={option.value}
            className={`pointer ${
              sortedValue === option.value ? "datetext" : ""
            }`}
            onClick={() => {
              onSortChange(option.value);
              setShowShortDrop(false);
            }}
          >
            <p className="d-flex gap-">
              {option.label}
              {sortedValue === option.value && (
                <span className="mb-0 ps-3">✓</span>
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const FilterSection = ({
  filterPopupRef,
  filtersPopupShow,
  setFiltersPopupShow,
  statusFilter,
  onFilterChange,
  onClearFilters,
}) => (
  <div
    className="d-flex gap-2 align-items-center filterTexts positionForFilterPopup"
    ref={filterPopupRef}
  >
    <p className="mb-0">Filters</p>
    <img
      className="pointer"
      src={FilterContacts}
      alt="filter-icon"
      onClick={() => setFiltersPopupShow(true)}
    />
    <div className="d-flex gap-0">
      <p className="allBorder px-1 pb-4 mb-0">{statusFilter}</p>
      <p
        className="xIconInvoice px-2 pb-4 mb-0 cursor-pointer d-none"
        onClick={onClearFilters}
      >
        x
      </p>
    </div>

    <section
      className="ocr-filter-popup"
      style={{
        transform: filtersPopupShow ? "scale(1)" : "scale(0)",
        transitionDuration: "300ms",
        top: "30px",
        left: "2px",
      }}
    >
      <p
        className="xCiecle ms-auto me-3 mt-1 pointer"
        onClick={() => setFiltersPopupShow(false)}
      >
        x
      </p>
      <div className="form-check underTexts">
        <input
          className="form-check-input pointer"
          style={{ borderRadius: "50%", width: "15px", height: "15px" }}
          type="checkbox"
          id="ascInvoice"
          checked={statusFilter.includes("All")}
          onChange={() => onFilterChange("All")}
        />
        <label className="form-check-label" htmlFor="filter-all">
          <p>All</p>
        </label>
      </div>
      <div className="form-check underTexts">
        <input
          className="form-check-input pointer"
          style={{ borderRadius: "50%", width: "15px", height: "15px" }}
          type="checkbox"
          id="ascInvoice"
          checked={statusFilter.includes("Pendent")}
          onChange={() => onFilterChange("Pendent")}
        />
        <label className="form-check-label" htmlFor="filter-pendent">
          <p>Pendent</p>
        </label>
      </div>
      <div className="form-check underTexts">
        <input
          className="form-check-input pointer"
          style={{ borderRadius: "50%", width: "15px", height: "15px" }}
          type="checkbox"
          id="ascInvoice"
          checked={statusFilter.includes("Accepted")}
          onChange={() => onFilterChange("Accepted")}
        />
        <label className="form-check-label" htmlFor="filter-accepted">
          <p>Accepted</p>
        </label>
      </div>
      <div className="form-check underTexts">
        <input
          className="form-check-input pointer"
          style={{ borderRadius: "50%", width: "15px", height: "15px" }}
          type="checkbox"
          id="ascInvoice"
          checked={statusFilter.includes("Deleted")}
          onChange={() => onFilterChange("Deleted")}
        />
        <label className="form-check-label" htmlFor="filter-rejected">
          <p>Deleted</p>
        </label>
      </div>
      <button className="clearButton mx-3" onClick={onClearFilters}>
        Clear
      </button>
    </section>
  </div>
);

const DateRangePicker = ({
  fromDate,
  toDate,
  fromDateOpen,
  toDateOpen,
  setFromDateOpen,
  setToDateOpen,
  onDateChange,
  fromDateRef,
  toDateRef,
}) => (
  <div className="d-flex gap-3 ocr-filter">
    <p className="mb-0">Dates</p>
    <div className="d-flex align-items-center">
      <img
        style={{ cursor: "", marginRight: "5px" }}
        src={Calender}
        alt=""
        onClick={() => setFromDateOpen(true)}
      />
      <AppDatePicker
        inputClassNames="date-picker-ocr"
        open={fromDateOpen}
        onOpenChange={(open) => setFromDateOpen(open)}
        selected={fromDate}
        onChange={(date) => {
          onDateChange("fromDate", date);
          setFromDateOpen(false);
        }}
        dateFormat="dd/MM/yyyy"
        className={"ps-1"}
      />
    </div>
    <p className="mb-0">To</p>
    <div className="d-flex align-items-center">
      <img
        style={{ cursor: "", marginRight: "5px" }}
        src={Calender}
        alt=""
        onClick={() => setToDateOpen(true)}
      />
      <AppDatePicker
        inputClassNames="date-picker-ocr"
        open={toDateOpen}
        onOpenChange={(open) => setToDateOpen(open)}
        selected={toDate}
        onChange={(date) => {
          onDateChange("toDate", date);
          setToDateOpen(false);
        }}
        dateFormat="dd/MM/yyyy"
        isDisabledForFuture={true}
        className={"ps-1"}
      />
    </div>
  </div>
);

const OcrDocumentsTable = ({
  ocrList,
  onDocumentClick,
  menuActive,
  setMenuActive,
  activeMenu,
  setActiveMenu,
  showDelete,
  setShowDelete,
  kebabRef,
  dispatch,
}) => (
  <div className="ocr-table-wrapper">
    <table className="table ocr-table">
      <thead>
        <tr>
          <th>Doc ID</th>
          <th>Date</th>
          <th>Supplier</th>
          <th>Amount Inc. VAT</th>
          <th>Due Date</th>
          <th>Status</th>
          <th> </th>
        </tr>
      </thead>
      <tbody>
        {ocrList.map((doc) => (
          <tr key={doc.id}>
            <td
              className="pointer ocr-doc-id"
              onClick={() => onDocumentClick(doc.id)}
            >
              {doc.docID}
            </td>
            <td>{moment(doc.docDate).format("DD.MM.YYYY")}</td>
            <td>{doc.supplierName}</td>
            <td>{europeanFormatWithSymbol(doc.docTotalAmount)}</td>
            <td>{moment(doc.docDate).format("DD.MM.YYYY")}</td>
            <td style={{ color: doc.status == "Pendent" ? "red" : "" }}>
              {doc.status}
            </td>
            <td style={{ position: "relative", width: "35px" }}>
              <img
                src={Kebab}
                alt="menu icon"
                className="quote-menu-icon inside-menu-work-ocr"
                style={{
                  transform:
                    doc.id === activeMenu && menuActive
                      ? "rotate(-90deg)"
                      : "rotate(0)",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (doc.id === activeMenu) {
                    setMenuActive(!menuActive);
                  } else {
                    setActiveMenu(doc.id);
                    setMenuActive(true);
                  }
                }}
              />
              {doc.id === activeMenu && (
                <section
                  ref={kebabRef}
                  onClick={(e) => e.stopPropagation()}
                  className="quote-menu quote-menu-2"
                  style={{
                    transform: menuActive ? "scale(1)" : "scale(0)",
                    transition: "transform 300ms",
                    top: "0",
                  }}
                >
                  <div className="menu-icon-cont">
                    <img
                      src={Kebab}
                      alt="menu icon"
                      className="quote-menu-icon inside-menu-work"
                      style={{ transform: "rotate(-90deg)" }}
                      onClick={() => setMenuActive(!menuActive)}
                    />
                  </div>
                  <div className="quote-menu-list fc">
                    <section
                      className="fr menu-single-item"
                      style={{ gap: "10px", alignItems: "center" }}
                      onClick={() => dispatch(OcrDocumentAccept(doc.id))}
                    >
                      <img
                        src={Reload}
                        alt="Menu Icons"
                        style={{ width: "21px", height: "21px" }}
                      />
                      <span>Accept</span>
                    </section>
                    <section
                      className="fr menu-single-item"
                      style={{ gap: "10px", alignItems: "center" }}
                      onClick={() => dispatch(OcrDocumentDuplicate(doc.id))}
                    >
                      <CopyIcon />
                      <span>Duplicate</span>
                    </section>
                    <section
                      className="fr menu-single-item"
                      style={{ gap: "10px", alignItems: "center" }}
                      onClick={() => setShowDelete(true)}
                    >
                      <img src={delete1} alt="Menu Icons" />
                      <span>Delete</span>
                      {showDelete && (
                        <DeletePopUp
                          animation={true}
                          handleDelete={() => {
                            dispatch(OcrDocumentDelete(activeMenu));
                          }}
                          show={showDelete}
                          onHide={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowDelete(false);
                          }}
                          title1={"This data will be removed from the system"}
                          title2={"and cannot be undone."}
                          title3={"Do you want to proceed?"}
                          no={"No"}
                          yes={"Yes"}
                        />
                      )}
                    </section>
                  </div>
                </section>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    {ocrList && ocrList.length === 0 && (
      <div className="row container d-flex position-relative ocr-no-result">
        <h6
          className="mt-1"
          style={{
            fontSize: "14px",
            fontWeight: 400,
            textAlign: "center",
            color: "#707070",
          }}
        >
          <br /> No results.
          <br /> Try to refine your filters or enter a new search.
        </h6>
      </div>
    )}
  </div>
);

export default OcrList;
